<template>
    <div class="c-notifications-panel"
        :data-component-name="$options.name"
    >
        <div class="c-notifications__inner -dark">
            <Notifications
                :globalPanel=true
                @set-current-date="$emit('set-current-date', $event)"
                v-if="toggledPanel"
             />
        </div>
    </div>
</template>

<script>
    import Notifications from '@/components/notifications/Notifications'
    
    export default {
        name: 'NotificationsPanel',
        components: {
            Notifications
        },
        props:{
            toggledPanel: {
                type: Boolean,
                default: false
            }
        }
    };
</script>

<style lang="scss">
    @import "@/scss/components/notifications/Notifications.scss";
</style>